import { signInWithCustomToken } from '@firebase/auth';
import type { User } from '@firebase/auth';

import { auth } from './firebase';

export const getUser = (): User | undefined => (auth ? (auth.currentUser ?? undefined) : undefined);

export const loginWithToken = async (tokenPromise: Promise<string>): Promise<string> => {
	const token = await tokenPromise;

	if (!auth) {
		throw new Error('Auth not initialized while login');
	}

	const userCredential = await signInWithCustomToken(auth, token);

	return userCredential.user.getIdToken();
};

export const forceRefreshToken = async (): Promise<void> => {
	const user = getUser();

	if (!user) {
		throw new Error('No user found');
	}

	await user.getIdToken(true);
};

export const logout = async (): Promise<void> => {
	if (!auth) {
		return;
	}

	await auth.signOut();
};
